import { render, staticRenderFns } from "./tension-chart.vue?vue&type=template&id=36230ae0"
import script from "./tension-chart.vue?vue&type=script&lang=js"
export * from "./tension-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports